<router-outlet *ngIf="displayApp"></router-outlet>
